export default __webpack_public_path__ + "static/media/results-found.d86aa0fa.png";